/**
 * Chart Modal Header Component
 *
 * Modal header with title, subtitle, export button, and close button
 */

import { X, Download } from 'lucide-react';
import { format } from 'date-fns';

interface ChartModalHeaderProps {
  title: string;
  subtitle: string;
  lastUpdated?: Date;
  onClose: () => void;
  onExport: () => void;
}

export function ChartModalHeader({
  title,
  subtitle,
  lastUpdated,
  onClose,
  onExport
}: ChartModalHeaderProps) {
  return (
    <div className="border-b border-slate-700/50 p-6">
      <div className="flex items-start justify-between">
        <div>
          <h2 className="text-2xl font-bold text-white mb-2">{title}</h2>
          <p className="text-slate-400 text-sm">
            {subtitle}
            {lastUpdated && (
              <span className="ml-4 text-slate-500">
                Updated: {format(lastUpdated, 'MMM d, yyyy h:mm a')}
              </span>
            )}
          </p>
        </div>

        <div className="flex items-center gap-3">
          {/* Export Button */}
          <button
            onClick={onExport}
            className="px-4 py-2 rounded-lg border transition-all flex items-center gap-2 hover:bg-cyan-500/20"
            style={{
              background: 'rgba(0, 212, 255, 0.1)',
              borderColor: 'rgba(0, 212, 255, 0.3)',
              color: '#00D4FF'
            }}
          >
            <Download className="w-4 h-4" />
            <span className="text-sm font-medium">Export CSV</span>
          </button>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="p-2 rounded-lg border transition-all hover:bg-slate-700/50"
            style={{
              borderColor: 'rgba(148, 163, 184, 0.3)'
            }}
          >
            <X className="w-6 h-6 text-slate-400" />
          </button>
        </div>
      </div>
    </div>
  );
}
